import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DownloadFileService } from '@shared/modules/uploader/services/download-file.service';
import { Dialog } from 'primeng/dialog';
import { CapturumButtonComponent } from '@capturum/ui/button';
import { NgClass } from '@angular/common';
import { FileUrlPipe } from '@shared/modules/uploader/pipes/file-url.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-previewer-popup',
  templateUrl: './previewer-popup.component.html',
  styleUrls: ['./previewer-popup.component.scss'],
  imports: [Dialog, CapturumButtonComponent, FileUrlPipe, TranslatePipe, NgClass],
})
export class PreviewerPopupComponent implements AfterContentChecked {
  @Input() public items: any[];
  @Input() public deletable: boolean = false;
  @Input() public nameProperty: string = 'name';
  @Input() public imagePathProperty: string;
  @Input() public showThumbnail: boolean = true;
  @Input() public showFilename: boolean = true;
  @Input() public showPopup: boolean = false;
  @Input() public showLoader: boolean;
  @Input() public itemsToPreviewCount: number = 2;
  @Output() public removeClick: EventEmitter<string> = new EventEmitter();
  @Output() public cardClick: EventEmitter<string> = new EventEmitter();

  constructor(
    public readonly fileService: DownloadFileService,
    private readonly ref: ChangeDetectorRef,
  ) {}

  public ngAfterContentChecked(): void {
    this.ref.detectChanges();
  }

  public isImageFile(file: File): boolean {
    return file.type && file.type.includes('image');
  }

  public handleRemoveIconClick(event: Event, file: any): void {
    if (this.items.length <= 1) {
      this.showPopup = false;
    }

    event.stopPropagation();
    event.stopImmediatePropagation();

    this.removeClick.next(file);
  }
}
